/**
 * Device fingerprint (browser-stable ID) using FingerprintJS open-source.
 * Browsers don't expose IMEI or MAC for security; this is the closest equivalent.
 *
 * The result is cached in localStorage so subsequent loads are instant.
 */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const KEY = 'loveall:device_fp';

let _loaderPromise = null;

const loadFp = () => {
  if (!_loaderPromise) {
    _loaderPromise = FingerprintJS.load();
  }
  return _loaderPromise;
};

/**
 * Returns a stable device fingerprint string. Cached after first compute.
 */
export async function getDeviceFingerprint() {
  const cached = localStorage.getItem(KEY);
  if (cached) return cached;
  try {
    const fp = await loadFp();
    const result = await fp.get();
    const id = result.visitorId;
    if (id) {
      localStorage.setItem(KEY, id);
      return id;
    }
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') console.debug('[fp] failed:', err?.message);
  }
  // Fallback: synthesize a UA-based string (never null)
  const fallback = btoa(
    `${navigator.userAgent}|${screen.width}x${screen.height}|${Intl.DateTimeFormat().resolvedOptions().timeZone}`
  ).slice(0, 32);
  localStorage.setItem(KEY, fallback);
  return fallback;
}
